import script from "./ConsumptionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumptionManagement.vue?vue&type=script&setup=true&lang=js"

import "./ConsumptionManagement.vue?vue&type=style&index=0&id=2e4504ae&lang=scss"

const __exports__ = script;

export default __exports__